import config from "@/config";
import http from "@/utils/request";

export default {
	upload: {
		url: `${config.UPLOAD_URL}/file/upload`,
		name: "文件上传",
		post: async function (data, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	uploadOSS: {
		url: `${config.MAIN_URL}/api/v1/oss/annex`,
		name: "文件上传",
		post: async function (data, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	uploadToOSS: {
		url: `${config.MAIN_URL}/api/v1/oss/uploadToOSS`,
		name: "文件上传（文件下载名称与上传名称保持一致）",
		post: async function (data, config = {}) {
			return await http.post(this.url, data, config);
		},
	},
	uploadGlb: {
		url: `${config.MAIN_URL}/admin/api/file/glb`,
		name: "文件上传",
		post: async function (data) {
			return await http.post(this.url, data);
		},
	},
	select: {
		url: `${config.MAIN_URL}/common/dic/itemList`,
		name: "下拉列表查询",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	getCode: {
		url: `${config.MAIN_URL}/auth/v2/getSmsLoginCode`,
		name: "获取验证码",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	smsCodeLogin: {
		url: `${config.MAIN_URL}/auth/v2/terminal/smsCodeLogin`,
		name: "验证码登录",
		post: async function (data, config = {}) {
			return await http.post(this.url, data, config);
		},
	},

};
